// A router link styled like the shared Button (a <button> inside <a> is invalid HTML).
// Local to the shell work package; proposed for src/components/ui.tsx.
import { Link, type LinkProps } from 'react-router-dom'
import { cx } from '@/components/ui'

const styles = {
  primary: 'bg-brand text-white hover:bg-brand-dark',
  secondary: 'bg-card text-brand-dark border border-line-strong hover:bg-brand-light',
  ghost: 'bg-transparent text-brand-dark hover:bg-brand-light',
} as const

export function LinkButton({ variant = 'primary', block, className, ...rest }: LinkProps & { variant?: keyof typeof styles; block?: boolean }) {
  return (
    <Link
      {...rest}
      className={cx(
        'tap inline-flex items-center justify-center gap-2 rounded-lg px-4 text-center font-semibold no-underline transition',
        styles[variant],
        block && 'w-full',
        className,
      )}
    />
  )
}
